const VibrationAPI = {
  vibration(duration = 1000) {
    if (navigator.vibrate) navigator.vibrate(duration) 
  }
}

export default VibrationAPI;